<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer :loading="loading">
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<vxe-grid ref="hitchhikingList" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="添加" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$warehouse",
					"field": "warehouse",
					"title": "仓库",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":true,
						"radio": true
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "policytype",
					"title": "备货类型",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":true,
						"name": "policytype"
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			tabledata: {
				default: () => {
					return []
				}
			},
			data: {
				default: () => {
					return []
				}
			},
			warehouseid:{
				default: () => {
					return 0
				}
			},
			policytype:{
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {
				modal_model:false,
				modal_title: '搭车采购',
				modal_width:800,
				modal_height:600,
				loading:false
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 400
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					},{
						name: '导入商品编码',
						status: 'danger',
						code: 'import'
					},{
						name: '匹配',
						status: 'success',
						code: 'match'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [
					{
						field: 'goodscode',
						title: '商品编码',
						width:100,
						editRender: {
							name: '$input',
							props: {
								
							},
							events: {

							}
						},			
					}, 
					{
						field: 'purchasenum',
						title: '本次采购数量',
						width:100,
						editRender: {
							name: '$inputNumber',
							props: {
								
							},
							events: {
					
							}
						},			
					},
					{
						field: 'error',
						title: '搭车状态',
						sortable:true,
						slots: {
							default: ({row}) => {
								if(row.error == 1){
									return <span style="color:#F56C6C">失败</span>
								}else if(row.error == 0){
									return <span style="color:#67C23A">成功</span>
								}else{
									return null
								}
							}
						},
						width:100,
					},
					{
						field: 'result',
						title: '匹配结果',
						sortable:true,
						width:300,
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
				// gridOptions.editRules = {
				// 	c: [{
				// 		required: true
				// 	},{
				// 		validator({cellValue,row}){
				// 			return new Promise((resolve,reject)=>{
				// 				if( true ){
				// 					reject(new Error('自定义错误'))
				// 				}else{
				// 					resolve()
				// 				}
								
				// 			})
				// 		}
				// 	}]
				// }
			},
			list() {
				return new Promise((resolve) => {
					let data = JSON.parse(JSON.stringify(this.data))
					resolve({
						list: data
					})
				})
			},
			modal_init(){
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				rule.forEach((item)=>{
					if(item.field == 'policytype'){
						item.value = parseInt(this.policytype)
					}
				})
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				this.fApi.setValue('warehouse', this.warehouseid)
			},
			getgrid(){
				return this.$refs.hitchhikingList
			},
			match(){
				let data = this.getgrid().getTableData().visibleData
				data.forEach((item)=>{
					if(!item.goodscode){
						this.delete(item)
					}
				})
				data = this.getgrid().getTableData().visibleData
				if(!data.length){
					this.$message.error('暂无数据')
					return
				}
				let goodscode = data.map((item)=>{
					return item.goodscode
				})
				this.loading = true
				this.$api.stockwarning.hitchhiking({
					goodscode:goodscode,
					warehouseid:this.warehouseid,
					policytype:this.fApi.getValue('policytype'),
				}).then((res)=>{
					this.loading = false
					let supplierlist = this.tabledata.filter((item)=>{
						return !item.parentid
					})
					let goodslist = this.tabledata.filter((item)=>{
						return item.parentid
					})
					
					for (let item of data){
						item.ismatch = 1
						let target = res.find((_item)=>{
							return _item.goodscode == item.goodscode
						})
						if(target){
							let existgoods = goodslist.find((_item)=>{
								return _item.specCode == item.goodscode
							})
							if(existgoods){
								item.purchasenum = 0
								item.error = 1
								item.result = '商品已在清单中(无需搭车)'
								continue
							}

							let supplierexist = null
							if(target.sourcedata){
								if(!target.sourcedata.taxprice){
									item.purchasenum = 0
									item.error = 1
									item.result = '商品单价不存在'
									continue
								}
								for(let i = 0; i < target.sourcedata.supplieroptions.length; i++){
									supplierexist = supplierlist.find((_item)=>{
										return _item.supplierID == target.sourcedata.supplieroptions[i].supplierwlnid
									})
									if(supplierexist){
										target.sourcedata = {...target.sourcedata,...target.sourcedata.supplieroptions[i]}
										break
									}
								}
							}


							for(let i in target){
								if(i != 'purchasenum'){
									item[i] = target[i]
								}else{
									item[i] = (item[i]!=0&&item[i]) ? item[i] : target[i]
								}								
							}
							
							if(!supplierexist){
								item.error = 1
								item.purchasenum = 0
								item.result = '供应商不在清单中'
							}else{
								item.result = supplierexist.supplierName
							}
							
						}else{
							item.purchasenum = 0
							item.error = 1
							item.result = '系统错误'
						}
					}	

					// console.log(res)
				},()=>{
					this.loading = false
				})
			
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				let detail = this.getgrid().getTableData().visibleData
				detail = this.createDetail(detail)
				let notmatch = detail.some((item)=>{
					return item.ismatch!=1
				})
				if(notmatch){
					this.$message.error('存在未匹配项，提交前先点击匹配')
					return
				}
				detail = detail.filter((item)=>{
					return item.error == 0
				})
				this.$emit('submit',detail)
				this.modal_cancel()
				// console.log(detail)
			},
			createDetail(data){
				data = JSON.parse(JSON.stringify(data))
				data.forEach((item)=>{
					delete(item['_X_ROW_CHILD'])
					delete(item['_X_ROW_KEY'])
				})
				return data
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>